import { render, staticRenderFns } from "./InstructorCourseList.vue?vue&type=template&id=1a7d2e9c&"
import script from "./InstructorCourseList.vue?vue&type=script&lang=ts&"
export * from "./InstructorCourseList.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorCourseList.vue?vue&type=style&index=0&id=1a7d2e9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports